import React from 'react';
import { MemoryRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './edm/auth/AuthContext';
import { EditorPage } from './edm/pages/EditorPage';

import './edm/styles/tokens.css';
import './edm/styles/base.css';
import './edm/styles/editor.css';
import './edm/styles/auth.css';

/**
 * Embeds the vendored @edm/web drag-and-drop email editor inside Dashboard
 * Online. Config (template id, csrf, capabilities, identity) is injected by the
 * Blade view via data-props and stashed on window.__EMAIL_EDITOR__ for the API
 * adapter (edm/api/client.ts). We mount EditorPage directly on the template id
 * through a MemoryRouter so its useParams() resolves without the SPA's router.
 */
export default function EmailEditorMount(props) {
    const id = String(props.emailtemplateId ?? props.templateId ?? '');
    const capabilities = props.capabilities ?? { send_test: false, ai: false, eden: false };

    window.__EMAIL_EDITOR__ = {
        templateId: id,
        csrf: props.csrf ?? '',
        backUrl: props.backUrl ?? '/outbound/templates',
        capabilities,
        me: props.me ?? {
            user_id: '',
            account_id: '',
            roles: [],
            capabilities,
        },
    };

    return (
        <div className="edm-embed-root" style={{ height: '100%', minHeight: '80vh' }}>
            <MemoryRouter initialEntries={[`/emails/${id}`]}>
                <AuthProvider>
                    <Routes>
                        <Route path="/emails/:id" element={<EditorPage />} />
                    </Routes>
                </AuthProvider>
            </MemoryRouter>
        </div>
    );
}
